import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import {
  resourcesReports,
  resourcesOperators,
} from "../../../helpers/backend_helper";
import { getPolicyUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import { getStorageCompany, getStorageUser } from "../../../helpers/api_helper";
import Select from "react-select";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import ButtonHelper from "../../../helpers/ButtonHelper";
import dayjs from "dayjs";

const Excesos = () => {
  let timeElapsed = dayjs();
  let dateNow = `${timeElapsed.format("YYYY-MM-DD")}`;
  const [date, setDate] = useState({ initDate: dateNow, endDate: dateNow });
  const policy = getPolicyUser();
  const authUser = getStorageUser();
  const company = getStorageCompany();
  const [pending, setPending] = useState(false);
  const [operators, setOperators] = useState([]);
  const [operator, setOperator] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: company.id,
    initDate: dateNow,
    endDate: dateNow,
    operator_id: null,
  });
  const filtersOperators = { select: true };
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesReports("show", params, "excesosReport").then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, [filters]);
  useEffect(() => {
    let params = { params: filtersOperators };
    resourcesOperators("get", params).then((response) => {
      setOperators(response.data);
    });
  }, []);

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };

    resourcesReports("show", config, "excesosReport").then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte de Excesos.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  const columns = Columns();
  document.title = "Excesos|Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={false}
              tittle="Reporte de Excesos"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <ButtonHelper
                addButon={false}
                reportButons={true}
                actionReportButon={getReports}
              />
              <PeriodFilterHelper
                setFilters={setFilters}
                filters={filters}
                getReports={getReports}
                modal={modal}
                setModal={setModal}
              />
              <div className="col-sm-2">
                <label className="form-label">Operador:</label>
                <Select
                  style={{ padding: "01.25rem 0.5rem" }}
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={operator}
                  isSearchable={false}
                  name="week"
                  placeholder="Operador"
                  options={operators}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => [
                    setOperator(e),
                    setFilters({ ...filters, operator_id: e ? e.id : null }),
                    console.log(e),
                  ]}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Excesos;
